// A missing conversion rate must never relabel an amount in another currency.
export function accountDisplay(account, preferredCurrency, rates = {}) {
  const nativeCurrency = account?.currency || 'USD';
  const size = Math.max(0, Number.parseFloat(account?.size) || 0);
  const requested = preferredCurrency || nativeCurrency;
  if (!size || requested === nativeCurrency) return { accountSize:size, currency:nativeCurrency };
  const from = nativeCurrency === 'USD' ? 1 : rates[nativeCurrency];
  const to = requested === 'USD' ? 1 : rates[requested];
  if (!Number.isFinite(from) || from <= 0 || !Number.isFinite(to) || to <= 0) return { accountSize:size, currency:nativeCurrency };
  return { accountSize:size / from * to, currency:requested };
}

// Only callers with a single journal basis opt into this fallback. Combined
// accounts must not be multiplied by an unrelated account or journal balance.
export function returnDisplay(account, preferredCurrency, rates = {}, journalBalance = null) {
  if (account) return accountDisplay(account, preferredCurrency, rates);
  // The simple balance has its own explicit currency. An old account display
  // preference must not silently convert the currency the trader just chose.
  return accountDisplay(journalBalance ? { size: journalBalance.balance, currency: journalBalance.currency } : null);
}
